function getCssVarNameForColumn (column, paramName) {
  return `--m-table_${column}_param_${paramName}`;
}

export default getCssVarNameForColumn;
